const EmptyCartDisplay = () => {
  return (
    <div>
      <div className="flex flex-col items-center justify-center gap-y-4 py-16">
        <div className="text-small-regular flex h-6 w-6 items-center justify-center rounded-full bg-nelo-blue text-white">
          <span>0</span>
        </div>
        <span>Tu carrito de compras está vacío.</span>
      </div>
    </div>
  )
}

export default EmptyCartDisplay
